import React from 'react'
import { Button, ListGroup, ListGroupItem } from 'reactstrap';
import ModalWrapper from 'components/common/modalwrapper';
import { useToggle, translate } from 'utils/common';
import Products from './productlist';
import useProductSearchDisable from './productSearchDisableHook';
import isEmpty from 'lodash.isempty';
import {PROD_GROUP } from './productSearch.constant';
import classNames from 'classnames/bind';
export default function ProductSearch(props) {
    const { displayName, formID } = props.formInfo;
    const [modal, setModal] = useToggle(false);
    const modalToggle = () => setModal();
    const [disableEdit] = useProductSearchDisable(props);

    function addProduct(data) {
        props.onChange({ target: { name: props.name, value: data ? data : [] } })
    }
    const listgroupclsnames = classNames({
        "product-search-list": true,
        "height-scroll-300": !props.maxitems || (props.maxitems && props.maxitems!=1 )
    })
    return (
        <React.Fragment>
            <div className="position-relative flex-grow-1">
                {!isEmpty(props.value) && <ListGroup className={listgroupclsnames}>
                    {props.value && props.value.map((val) => (
                        <ListGroupItem key={val.id}>{val[displayName.mainName]} {val[displayName.subName] ? ` ( ${val[displayName.subName]} )` : ''} </ListGroupItem>
                    ))}
                </ListGroup>}
                {isEmpty(props.value) && <ListGroupItem className="product-search-list">No Data!</ListGroupItem>}
                <Button className={"prod-search-floating-btn " + (isEmpty(props.value) ? "" : "loaded")} color="secondary" onClick={() => modalToggle()} disabled={disableEdit || props.disabled}> {translate('add')} / {translate('edit')}</Button>
            </div>
            <ModalWrapper modal={modal} toggle={modalToggle} className="modal-xl" bodyCustomClass="pb-2"
                title="Add Products" submitBtnLabel="APPLY" onSubmit={addProduct}
                modalReturnValueInitial={props.value}>
                <Products className="pb-0" showLangFilter={formID== PROD_GROUP} formProps={{ ...props }}></Products>
            </ModalWrapper>
        </React.Fragment>
    )
}
